<button
    v-if="!link"
    :class="classes"
    :type="submit ? 'submit' : 'button'"
    :disabled="disabled"
    @click="$emit('click')"
    :style="styles">
    <AppIcon v-if="icon" :icon="icon" :color="iconColor" />
    <div class="btn-content">
        <slot></slot>
    </div>
</button>
<router-link v-else :class="classes" :to="link" :style="styles">
    <AppIcon v-if="icon" :icon="icon" :color="iconColor" />
    <slot></slot>
</router-link>